import { render } from "./Greenboard.vue?vue&type=template&id=0bfb48a6&scoped=true&ts=true"
import script from "./Greenboard.vue?vue&type=script&lang=ts"
export * from "./Greenboard.vue?vue&type=script&lang=ts"

import "./Greenboard.vue?vue&type=style&index=0&id=0bfb48a6&lang=scss&scoped=true"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfb48a6"]])

export default __exports__